import { render, staticRenderFns } from "./bigscreentitle.vue?vue&type=template&id=4d9424ec&scoped=true"
import script from "./bigscreentitle.vue?vue&type=script&lang=js"
export * from "./bigscreentitle.vue?vue&type=script&lang=js"
import style0 from "./bigscreentitle.vue?vue&type=style&index=0&id=4d9424ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9424ec",
  null
  
)

export default component.exports